function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { createStackNavigator } from "@react-navigation/stack";
import { memo } from "react";
import { TouchableWithoutFeedback, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { Icon } from "@oui/app-core/src/components/Icon";
import { Text } from "@oui/app-core/src/components/Text";
import { useTheme } from "@oui/app-core/src/styles";
import { LearnStatic } from "./LearnStatic";
function TabLabel(props) {
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            alignItems: 'center',
            paddingVertical: 2,
            marginTop: -4,
            width: '100%'
        },
        children: [
            /*#__PURE__*/ _jsx(Text, {
                text: props.text,
                color: props.color,
                size: 13,
                weight: "semibold",
                numberOfLines: 1,
                textAlign: "center"
            }),
            /*#__PURE__*/ _jsx(View, {
                style: {
                    backgroundColor: props.focused ? props.color : 'transparent',
                    height: 2,
                    width: '70%'
                }
            })
        ]
    });
}
var StaticAccountSettingsStack = createStackNavigator();
var StaticAccountSettings = function(param) {
    var AccountSettings = param.AccountSettings;
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(StaticAccountSettingsStack.Navigator, {
        screenOptions: {
            headerTintColor: theme.color.primary100,
            headerTitleStyle: {
                color: theme.color.dark,
                fontFamily: 'OpenSansSemiBold'
            }
        },
        children: /*#__PURE__*/ _jsx(StaticAccountSettingsStack.Screen, {
            name: "StaticAccount",
            component: AccountSettings
        })
    });
};
var StaticTab = createBottomTabNavigator();
// use React.memo due to note about performance from https://reactnavigation.org/docs/screen#children
export var StaticTabNavigator = /*#__PURE__*/ memo(function(param) {
    var AccountSettings = param.AccountSettings;
    var insets = useSafeAreaInsets();
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsxs(StaticTab.Navigator, {
        screenOptions: function(param) {
            var route = param.route;
            // not sure why this type isn't inferred correctly but we have to manually specify otherwise
            // any object is accepted as a return value
            var options = {
                headerShown: false,
                tabBarStyle: {
                    height: 60 + insets.bottom
                },
                tabBarActiveTintColor: theme.color.primary100,
                tabBarInactiveTintColor: theme.color.gray500,
                tabBarHideOnKeyboard: true,
                // Adapted from https://github.com/react-navigation/react-navigation/blob/a484c1d7834f195ac0cfccda6a9f905218bc2274/packages/bottom-tabs/src/views/BottomTabItem.tsx#L156-L164
                // customized accessibilityRole
                tabBarButton: function(_param) {
                    var children = _param.children, style = _param.style, onPress = _param.onPress, to = _param.to, accessibilityRole = _param.accessibilityRole, rest = _object_without_properties(_param, [
                        "children",
                        "style",
                        "onPress",
                        "to",
                        "accessibilityRole"
                    ]);
                    return /*#__PURE__*/ _jsx(TouchableWithoutFeedback, _object_spread_props(_object_spread({}, rest), {
                        role: "tab",
                        onPress: onPress,
                        children: /*#__PURE__*/ _jsx(View, {
                            style: style,
                            children: children
                        })
                    }));
                },
                tabBarIcon: function(param) {
                    var tintColor = param.color;
                    var routeName = route.name;
                    var icon = null;
                    if (routeName === 'Learn') {
                        icon = /*#__PURE__*/ _jsx(Icon, {
                            color: tintColor,
                            name: "sessions"
                        });
                    } else if (routeName === 'Profile') {
                        icon = /*#__PURE__*/ _jsx(Icon, {
                            color: tintColor,
                            name: "person"
                        });
                    }
                    return /*#__PURE__*/ _jsx(View, {
                        style: {
                            paddingTop: 4
                        },
                        children: icon
                    });
                }
            };
            return options;
        },
        children: [
            /*#__PURE__*/ _jsx(StaticTab.Screen, {
                name: "Learn",
                component: LearnStatic,
                options: {
                    title: 'Learn',
                    tabBarLabel: function(p) {
                        return /*#__PURE__*/ _jsx(TabLabel, _object_spread_props(_object_spread({}, p), {
                            text: "Learn"
                        }));
                    },
                    tabBarTestID: 'NAV_Learn',
                    tabBarAccessibilityLabel: 'Learn, 1 of 2'
                }
            }),
            /*#__PURE__*/ _jsx(StaticTab.Screen, {
                name: "Profile",
                options: {
                    title: 'Profile',
                    tabBarLabel: function(p) {
                        return /*#__PURE__*/ _jsx(TabLabel, _object_spread_props(_object_spread({}, p), {
                            text: "Account"
                        }));
                    },
                    tabBarTestID: 'NAV_Account',
                    tabBarAccessibilityLabel: 'Account, 2 of 2'
                },
                children: function() {
                    return /*#__PURE__*/ _jsx(StaticAccountSettings, {
                        AccountSettings: AccountSettings
                    });
                }
            })
        ]
    });
});
